import script from "./RecintosList.vue?vue&type=script&setup=true&lang=js"
export * from "./RecintosList.vue?vue&type=script&setup=true&lang=js"

import "./RecintosList.vue?vue&type=style&index=0&id=3f978b85&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f978b85"]])

export default __exports__